import actions from './actions';

export const initialState = {
  arrivalLock: null,
  browserReferer: null,
  cloudflareHeaders: {},
  hasAcceptedAgreement: true,
  isCollapsed: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case actions.SET_ARRIVAL_LOCK:
      return {
        ...state,
        arrivalLock: action.payload,
      };
    case actions.SET_BROWSER_REFERER:
      return {
        ...state,
        browserReferer: action.payload,
      };
    case actions.SET_CLOUDFLARE_HEADERS:
      return {
        ...state,
        cloudflareHeaders: action.payload,
      };
    case actions.SET_SHOW_SSO_MODAL:
      return {
        ...state,
        ssoModal: action.payload,
      };
    case actions.HIDE_SSO_MODAL:
      return {
        ...state,
        ssoModal: {
          showModal: false,
        },
      };
    case actions.SET_IS_POLICY_ACCEPTED:
      return {
        ...state,
        hasAcceptedAgreement: action.payload,
      };
    case actions.SET_IS_NAV_COLLAPSED:
      return {
        ...state,
        isCollapsed: action.payload,
      };
    default:
      return state;
  }
}
